module.exports = (s) => {
  return {
    parent_game_id: {
      label: '游戏',
      type: 'select-tree',
      props: {
        style: { width: '300px' },
        options: [],
        ischeckbox: false,
        'check-on-click-node': true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children',
        },
        'select-props': {
          placeholder: '请选择游戏',
          size: 'mini',
          clearable: true,
          accordion: true,
        },
      },
      on: {
        getValue: (parent_game_id) => {
          s.dialog_config.form_config.parent_game_id.value = parent_game_id;
        },
      },
      value: null,
      rules: { required: true, trigger: ['change'], message: '请选择游戏' },
    },
    labels: {
      label: '标签',
      type: 'input',
      props: {
        type: 'textarea',
        autosize: { minRows: 6 },
        placeholder: '一次最多能添加20个标签，每个标签以“、”分割。\n每个标签最大长度限制10个字',
      },
      value: '',
      rules: [
        {
          required: true,
          trigger: ['change'],
          message: '请输入标签！',
          validator: (rule, value, callback) => {
            value ? callback() : callback(new Error(rule.message));
          },
        },
        {
          required: true,
          trigger: ['change'],
          maxLength: 20,
          validator: (rule, value, callback) => {
            const valid = (value?.split('、') || []).length <= rule.maxLength;
            valid ? callback() : callback(new Error(`一次最多能添加${rule.maxLength}个标签！`));
          },
        },
        {
          required: true,
          trigger: ['change'],
          maxLength: 10,
          getMessage: (maxLength) => `每个标签最大长度限制${maxLength}个字`,
          validator: (rule, value, callback) => {
            const valid = (value?.split('、') || []).every((tag) => (tag.length <= rule.maxLength));
            valid ? callback() : callback(new Error(rule.getMessage(rule.maxLength)));
          },
        },
      ],
    },
    level: {
      label: '标签等级',
      type: 'select',
      options: [
        {
          label: '一级标签',
          value: 1,
        },
        {
          label: '二级标签',
          value: 2,
        },
      ],
      props: {
        placeholder: '请选择标签等级',
      },
      rules: { required: true, trigger: ['change'], message: '请选择标签等级' },
      value: '',
    },
  };
};
